<template>
    <section class="min-h-32 bg-gray-800 py-16 px-8 xl:px-48 3xl:px-96 text-gray-200 text-sm md:text-xs lg:text-sm">
        <div class="text-center space-y-6 md:text-left md:space-y-0 md:flex md:justify-between">
            <div class="my-auto">
                <!-- <p class="text font-semibold">Disclaimer:</p> -->
                <p class="text-sm">We are a 501c3 organization and <br> all donations are tax deductable.
                <br>
                 EIN: 84-4926332
                </p>
            </div>
            <div class="my-auto">
                <p>
                    &copy; Copyright {{currentYear}} - Thrive Unburdened, Inc
                </p>
                <p class="pl-4">
                    1610-B S 5th St, 
                    Leesville, LA 71446
                </p>
            </div>
            <div class="my-auto">
                <p class="space-x-2">
                    <span class="text-sm"> Made With </span><span class="text-red-600 my-auto"><i class="fas fa-heart"></i></span>
                    <span class="text-lg">+</span><span class="my-auto text-yellow-900"><i class="fas fa-mug-hot"></i></span>
                    <span class="text-sm"> 
                        By <a href="https://github.com/freinet12" target="_blank" class="pl-1 text-gray-400 hover:text-gray-300">
                        Freinet Brutus </a>
                    </span>
                </p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Footer',
    computed: {
        currentYear(){
            return new Date().getFullYear()
        }
    }
}
</script>

<style scoped>

</style>